<template>
  <div >
    <el-card class="box-card" >
        <div class="product">
            <div class="img">
                <img :src="product.bigImg" />
            </div>
            <div class="title">{{product.name}}</div>
            <div class="price">￥{{product.price}}/{{product.unit}}</div>
            <div class="buy" @click="turn">
                <span>立即购买 &gt;</span>
            </div>
        </div>
        <el-tabs v-model="activeName" >
            <el-tab-pane label="课程介绍" name="first">
                <div class="detail" v-if="id==5" >
                    <p><img src="@/assets/kc05.png" /></p>
                </div>
                <div class="detail" v-if="id==6" >
                    <p><img src="@/assets/kc06.png" /></p>
                </div>
                <div class="detail" v-if="id==7" >
                    <p><img src="@/assets/kc07.png" /></p>
                </div>
            </el-tab-pane>
            <el-tab-pane label="医生介绍" name="second">
                <div class="detail"  >
                <p><img src="@/assets/doctor.png" /></p>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Detail',
  data : function(){
    return {
        id : null,
        product : {},
        activeName : "first"
    }
  },
  created() {
      this.id = this.$route.params.id
      this.product =  JSON.parse(window.localStorage.getItem('product')||'{}')
  },
  methods : {
      turn(){
          this.$router.push({
              name : 'Order'
          })
      }
  }
}
</script>

<style>
.detail p{
    margin: 0;
    padding: 0;
}
.detail img{
    display: block;
    width: 100%;
}
.product{
    text-align: left;
    line-height: 1.5;
    position: relative;
}
.product .img img{
    width: 100%;
}
.product .title{
    
}
.product .price{
    color: #BD82A6;
}
.product .buy{
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
}
.product .buy span{
    padding: 5px 8px;
    background: #000000;
    border-radius: 2px;
    cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/pages/Detail2.vue